import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I'm an electronic engineer from Universidad de Buenos Aires.
              <br />
              <br />I've done many projects that include 
              <i>
                <b className="purple"> robots, IIOT products, game development, electronic toys, machine Learing and more. </b>
              </i>
              <br />
              <br /> I like to think of myself as a jack of all trades, knowing that any problem I'm thrown, I will be able to solve it.
              <br />
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
